import {
  EXPENSE_FETCHING,
  EXPENSE_FAILED,
  EXPENSE_SUCCESS,
  EXPENSE_DETAIL_FETCHING,
  EXPENSE_DETAIL_FAILED,
  EXPENSE_DETAIL_SUCCESS,
} from "./types";

import ExpenseService from "../services/expense.service";

export const clearExpense = () => async (dispatch) => {
  dispatch({
    type: EXPENSE_SUCCESS,
    payload: null,
  });
};

export const getAllExpense = () => async (dispatch) => {
  try {
    dispatch({
      type: EXPENSE_FETCHING,
    });
    const res = await ExpenseService.getAllExpense();
    if (res) {
      dispatch({
        type: EXPENSE_SUCCESS,
        payload: res.data,
      });
      return res;
    }
  } catch (error) {
    dispatch({
      type: EXPENSE_FAILED,
    });
    return error;
  }
};

export const getExpenseGeneralById = (idExpense) => async (dispatch) => {
  try {
    dispatch({
      type: EXPENSE_DETAIL_FETCHING,
    });
    const res = await ExpenseService.getExpenseGeneralById(idExpense);
    if (res) {
      dispatch({
        type: EXPENSE_DETAIL_SUCCESS,
        payload: res.data,
      });
      //return res;
    }
  } catch (error) {
    dispatch({
      type: EXPENSE_DETAIL_FAILED,
    });
    return error;
  }
};

export const addExpenseGeneral = (idEmp, formData) => async () => {
  try {
    const res = await ExpenseService.addExpenseGeneral(idEmp, formData);
    if (res) {
      console.log(res);
      return res;
    }
  } catch (error) {
    return error;
  }
};

export const updateFileExpense = (idEmp, formData) => async () => {
  try {
    const res = await ExpenseService.updateFileExpense(idEmp, formData);
    if (res) {
      console.log(res);
      return res;
    }
  } catch (error) {
    return error;
  }
};

export const updateStatusExpense = (idExpense, data) => async () => {
  try {
    const res = await ExpenseService.updateStatusExpense(idExpense, data);
    if (res) {
      console.log(res);
      return res;
    }
  } catch (error) {
    return error;
  }
};

export const updateExpenseGeneral = (idEmp, formData) => async () => {
  try {
    const res = await ExpenseService.updateExpenseGeneral(idEmp, formData);
    if (res) {
      console.log(res);
      return res;
    }
  } catch (error) {
    return error;
  }
};

export const getExpenseAllowanceById = (idExpense) => async (dispatch) => {
  try {
    dispatch({
      type: EXPENSE_DETAIL_FETCHING,
    });
    const res = await ExpenseService.getExpenseAllowanceById(idExpense);
    if (res) {
      dispatch({
        type: EXPENSE_DETAIL_SUCCESS,
        payload: res.data,
      });
      return res;
    }
  } catch (error) {
    dispatch({
      type: EXPENSE_DETAIL_FAILED,
    });
    return error;
  }
};

export const addExpenseAllowance = (idEmp, formData) => async () => {
  try {
    const res = await ExpenseService.addExpenseAllowance(idEmp, formData);
    if (res) {
      console.log(res);
      return res;
    }
  } catch (error) {
    return error;
  }
};

export const updateExpenseAllowance = (idEmp, formData) => async () => {
  try {
    const res = await ExpenseService.updateExpenseAllowance(idEmp, formData);
    if (res) {
      console.log(res);
      return res;
    }
  } catch (error) {
    return error;
  }
};

export const getExpenseMileageById = (idExpense) => async (dispatch) => {
  try {
    dispatch({
      type: EXPENSE_DETAIL_FETCHING,
    });
    const res = await ExpenseService.getExpenseMileageById(idExpense);
    if (res) {
      dispatch({
        type: EXPENSE_DETAIL_SUCCESS,
        payload: res.data,
      });
      return res;
    }
  } catch (error) {
    dispatch({
      type: EXPENSE_DETAIL_FAILED,
    });
    return error;
  }
};

export const addExpenseMileage = (idEmp, formData) => async () => {
  try {
    const res = await ExpenseService.addExpenseMileage(idEmp, formData);
    if (res) {
      console.log(res);
      return res;
    }
  } catch (error) {
    return error;
  }
};

export const updateExpenseMileage = (idEmp, formData) => async () => {
  try {
    const res = await ExpenseService.updateExpenseMileage(idEmp, formData);
    if (res) {
      console.log(res);
      return res;
    }
  } catch (error) {
    return error;
  }
};

export const getExpenseWelfareById = (idExpense) => async (dispatch) => {
  try {
    dispatch({
      type: EXPENSE_DETAIL_FETCHING,
    });
    const res = await ExpenseService.getExpenseWelfareById(idExpense);
    if (res) {
      dispatch({
        type: EXPENSE_DETAIL_SUCCESS,
        payload: res.data,
      });
      return res;
    }
  } catch (error) {
    dispatch({
      type: EXPENSE_DETAIL_FAILED,
    });
    return error;
  }
};

export const addExpenseWelfare = (idEmp, formData) => async () => {
  try {
    const res = await ExpenseService.addExpenseWelfare(idEmp, formData);
    if (res) {
      console.log(res);
      return res;
    }
  } catch (error) {
    return error;
  }
};

export const updateExpenseWelfare = (idEmp, formData) => async () => {
  try {
    const res = await ExpenseService.updateExpenseWelfare(idEmp, formData);
    if (res) {
      console.log(res);
      return res;
    }
  } catch (error) {
    return error;
  }
};

export const getExpenseFlexCoinById = (idExpense) => async (dispatch) => {
  try {
    dispatch({
      type: EXPENSE_DETAIL_FETCHING,
    });
    const res = await ExpenseService.getExpenseFlexCoinById(idExpense);
    if (res) {
      dispatch({
        type: EXPENSE_DETAIL_SUCCESS,
        payload: res.data,
      });
      return res;
    }
  } catch (error) {
    dispatch({
      type: EXPENSE_DETAIL_FAILED,
    });
    return error;
  }
};

export const addExpenseFlexCoin = (idEmp, formData) => async () => {
  try {
    const res = await ExpenseService.addExpenseFlexCoin(idEmp, formData);
    if (res) {
      console.log(res);
      return res;
    }
  } catch (error) {
    return error;
  }
};

export const updateExpenseFlexCoin = (idEmp, formData) => async () => {
  try {
    const res = await ExpenseService.updateExpenseFlexCoin(idEmp, formData);
    if (res) {
      console.log(res);
      return res;
    }
  } catch (error) {
    return error;
  }
};

export const deleteExpenseGeneral = (idEmp, data) => async () => {
  try {
    const res = await ExpenseService.deleteExpenseGeneral(idEmp, data);
    if (res) {
      console.log(res);
      return res;
    }
  } catch (error) {
    return error;
  }
};

export const deleteExpenseMileage = (idEmp, data) => async () => {
  try {
    const res = await ExpenseService.deleteExpenseMileage(idEmp, data);
    if (res) {
      console.log(res);
      return res;
    }
  } catch (error) {
    return error;
  }
};

export const deleteExpenseAllowance = (idEmp, data) => async () => {
  try {
    const res = await ExpenseService.deleteExpenseAllowance(idEmp, data);
    if (res) {
      console.log(res);
      return res;
    }
  } catch (error) {
    return error;
  }
};

export const deleteExpenseWelfare = (idEmp, data) => async () => {
  try {
    const res = await ExpenseService.deleteExpenseWelfare(idEmp, data);
    if (res) {
      console.log(res);
      return res;
    }
  } catch (error) {
    return error;
  }
};

export const deleteExpenseFlexCoin = (idEmp, data) => async () => {
  try {
    const res = await ExpenseService.deleteExpenseFlexCoin(idEmp, data);
    if (res) {
      console.log(res);
      return res;
    }
  } catch (error) {
    return error;
  }
};

export const getAllExpenseByIdCompany = () => async (dispatch) => {
  try {
    dispatch({
      type: EXPENSE_FETCHING,
    });
    const res = await ExpenseService.getAllExpenseByIdCompany();
    if (res) {
      dispatch({
        type: EXPENSE_SUCCESS,
        payload: res.data,
      });
      return res;
    }
  } catch (error) {
    dispatch({
      type: EXPENSE_FAILED,
    });
    return error;
  }
};

export const getHistoryExpenseByIdCompany = () => async (dispatch) => {
  try {
    dispatch({
      type: EXPENSE_FETCHING,
    });
    const res = await ExpenseService.getHistoryExpenseByIdCompany();
    if (res) {
      dispatch({
        type: EXPENSE_SUCCESS,
        payload: res.data,
      });
      return res;
    }
  } catch (error) {
    dispatch({
      type: EXPENSE_FAILED,
    });
    return error;
  }
};

export const getFilteredHistoryExpenseAccountant =
  (data) => async (dispatch) => {
    try {
      dispatch({
        type: EXPENSE_FETCHING,
      });
      const res = await ExpenseService.getFilteredHistoryExpenseAccountant(
        data
      );
      if (res) {
        dispatch({
          type: EXPENSE_SUCCESS,
          payload: res.data,
        });
        return res;
      }
    } catch (error) {
      dispatch({
        type: EXPENSE_FAILED,
      });
      return error;
    }
  };

export const getAllExpenseByIdApprover = () => async (dispatch) => {
  try {
    dispatch({
      type: EXPENSE_FETCHING,
    });
    const res = await ExpenseService.getAllExpenseByIdApprover();
    if (res) {
      dispatch({
        type: EXPENSE_SUCCESS,
        payload: res.data,
      });
      return res;
    }
  } catch (error) {
    dispatch({
      type: EXPENSE_FAILED,
    });
    return error;
  }
};

export const getHistoryExpenseForApprover = () => async (dispatch) => {
  try {
    dispatch({
      type: EXPENSE_FETCHING,
    });
    const res = await ExpenseService.getHistoryExpenseForApprover();
    if (res) {
      dispatch({
        type: EXPENSE_SUCCESS,
        payload: res.data,
      });
      return res;
    }
  } catch (error) {
    dispatch({
      type: EXPENSE_FAILED,
    });
    return error;
  }
};

export const getFilteredHistoryExpenseApprover = (data) => async (dispatch) => {
  try {
    dispatch({
      type: EXPENSE_FETCHING,
    });
    const res = await ExpenseService.getFilteredHistoryExpenseApprover(data);
    if (res) {
      dispatch({
        type: EXPENSE_SUCCESS,
        payload: res.data,
      });
      return res;
    }
  } catch (error) {
    dispatch({
      type: EXPENSE_FAILED,
    });
    return error;
  }
};

export const getAllExpenseByIdReviewer = () => async (dispatch) => {
  try {
    dispatch({
      type: EXPENSE_FETCHING,
    });
    const res = await ExpenseService.getAllExpenseByIdReviewer();
    if (res) {
      dispatch({
        type: EXPENSE_SUCCESS,
        payload: res.data,
      });
      return res;
    }
  } catch (error) {
    dispatch({
      type: EXPENSE_FAILED,
    });
    return error;
  }
};
